import React from "react";
import DefaultContainer from "../components/container/DefaultContainer";
import Footer from "../components/container/Footer";
import MainNaviagation from "../components/navigation/MainNaviagation";
import { GridBeam } from "../components/ui/background-grid-beam";
import { motion } from "framer-motion";
import { MapPin, Phone, Printer } from "lucide-react";
import ThirdInnerItem from "../components/inner/main/third/ThirdInnerItem";

// / Vendor & Product 이미지 임포트
import vendorIcon1 from "../assets/main/vendorIcon1.png";
import vendorIcon2 from "../assets/main/vendorIcon2.png";
import vendorIcon3 from "../assets/main/vendorIcon3.png";
import vendorIcon4 from "../assets/main/vendorIcon4.png";
import styled, { keyframes, createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

const businessCards = [
  {
    item: vendorIcon1,
    text: "Semiconductor Packaging",
    link: "반도체 패키징",
    description:
      "핵심 웨이퍼·기판·공정 장비를 빠르게 매칭해 수율 안정화와 양산 안정성을 동시에 잡습니다.",
  },
  {
    item: vendorIcon2,
    text: "EV Battery",
    link: "EV 배터리",
    description:
      "셀 제조·팩 조립·BMS 관련 부품/장비 조달까지 밸류체인 전 구간을 연결하는 공급 구조를 구성합니다.",
  },
  {
    item: vendorIcon3,
    text: "ICT Device & Network",
    link: "ICT Device & Network",
    description:
      "통신·센서·테스트 장비 협력사를 한 번에 탐색해 프로젝트 단계별로 필요한 자원을 신속히 확보합니다.",
  },
  {
    item: vendorIcon4,
    text: "LG Electronic B2B",
    link: "LG전자 B2B",
    description:
      "글로벌 제조 역량과 연계된 검증된 공급 네트워크로 물류·납기·품질의 일관성을 유지합니다.",
  },
]

const sectionRevealProps = (delay = 0) => ({
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.26 },
  transition: {
    duration: 0.65,
    ease: "easeOut",
    delay,
  },
});

const Main = () => {
  return (
    <>
      <HideScrollbar />
      <div
        style={{
          overflowY: "scroll",
          overflowX: "hidden",
          width: "100%",
          height: "100%",
          scrollbarWidth: "none",
        }}
      >
    <DefaultContainer>
      <MainNaviagation />
      <HeroBand>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            padding: "3rem 0 2.7rem",
            minHeight: "100vh",
            overflow: "hidden",
            border: "1px solid rgba(190, 199, 255, 0.2)",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "#080C18",
              zIndex: 0,
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(17, 23, 66, 0.36)",
              zIndex: 1,
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(circle at 12% 10%, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.04) 28%, rgba(255, 255, 255, 0) 48%)",
              zIndex: 1.5,
            }}
          />
          <HeroPulse />
          <HeroPulseRing />
          <HeroSweep />
        <GridBeam
            className="flex items-center justify-center text-center relative h-full"
            style={{ zIndex: 2, filter: "none", backdropFilter: "none" }}
          >
            <div
              className="grid gap-2"
              style={{
                filter: "none",
                backdropFilter: "none",
                position: "relative",
                zIndex: 10,
              }}
            >
              <HeroTitle
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.85, ease: "easeOut" }}
              >
                Leading Access For Customer’s Success
              </HeroTitle>
              <HeroDescription
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.85, ease: "easeOut", delay: 0.18 }}
              >
                Technology-first sourcing in Semiconductor, EV Battery, and ICT—<br />
                Lacess turns global innovation into manufacturing-ready customer solutions.
              </HeroDescription>
              <HeroCTA
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.75, ease: "easeOut", delay: 0.34 }}
                to="/company"
              >
                Company & Capabilities
              </HeroCTA>
            </div>
          </GridBeam>
        </div>
      </HeroBand>

      <MainSection id="company" $lightBg>
        <SectionCanvas>
          <SectionPulse />
          <SectionPulseRing />
          <VisionPanel>
            <motion.div {...sectionRevealProps()}>
              <CompanyEyebrow>Company Snapshot</CompanyEyebrow>
            </motion.div>
            <motion.div {...sectionRevealProps(0.06)}>
              <CompanyTitle>Leading Access For Customer’s Success</CompanyTitle>
            </motion.div>
            <motion.div {...sectionRevealProps(0.12)}>
              <CompanyMission>
                2010년 설립 이래 라세스는 반도체, EV Battery, ICT Device 산업에서 주요 소재·부품·장비를 공급하며
                글로벌 기술 파트너와 고객사가 안정적으로 성장할 수 있도록 설계·검증·연결해 왔습니다.
              </CompanyMission>
            </motion.div>
            <motion.div {...sectionRevealProps(0.2)}>
              <CompanyMission>
                단순 유통이 아닌, 고객의 과업을 완성하는 동반자로서 프로젝트 타임라인과 기술 리스크를 함께 최적화합니다.
              </CompanyMission>
            </motion.div>
            <motion.div {...sectionRevealProps(0.26)}>
              <MainAction to="/company">About Lacess</MainAction>
            </motion.div>
          </VisionPanel>
        </SectionCanvas>
      </MainSection>

      {/* 두 번째 칸 */}
      <MainSection id="biz-area" $compact $lightBg $mobileTight>
        <SectionCanvas>
          <SectionPulseBiz />
          <SectionPulseRingBiz />
          <motion.div {...sectionRevealProps()}>
            <SectionLabel>Biz Area</SectionLabel>
          </motion.div>
          <motion.div {...sectionRevealProps(0.07)}>
            <SectionHeading>Core Industries</SectionHeading>
          </motion.div>
          <motion.div {...sectionRevealProps(0.12)}>
            <SectionLead>
              고객사 니즈를 기반으로 수직/수평으로 연결된 밸류체인에서 최적 조달 경로를 제시합니다.
            </SectionLead>
          </motion.div>
          <motion.div {...sectionRevealProps(0.18)}>
            <BizJumpButton to="/vendor/Eternal">Vendor &amp; Product 보기</BizJumpButton>
          </motion.div>
          <motion.div {...sectionRevealProps(0.22)} id="vendor-product">
            <SectionLabel>Vendor Insight</SectionLabel>
          </motion.div>
          <motion.div {...sectionRevealProps(0.25)}>
            <SectionLead>
              Industries 기반 공급 역량을 기준으로 각 벤더군의 특성과 기여 포인트를 한눈에 확인하세요.
            </SectionLead>
          </motion.div>
          <VendorDescriptionGrid>
            {businessCards.map((card, index) => (
              <motion.div key={`vendor-desc-${card.text}`} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }} transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}>
                <VendorDescriptionCard>
                  <VendorDescriptionTitle>{card.text}</VendorDescriptionTitle>
                  <VendorDescriptionText>{card.description}</VendorDescriptionText>
                </VendorDescriptionCard>
              </motion.div>
            ))}
          </VendorDescriptionGrid>
          <motion.div {...sectionRevealProps(0.2)}>
            <SectionLabel>Vendor &amp; Product</SectionLabel>
          </motion.div>
          <VendorGrid>
            {businessCards.map((card, index) => (
              <VendorCardItem
                key={card.text}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{
                  duration: 0.65,
                  delay: index * 0.12,
                  ease: "easeOut",
                }}
              >
                <ThirdInnerItem item={card.item} text={card.text} link={card.link} />
              </VendorCardItem>
            ))}
          </VendorGrid>
        </SectionCanvas>
      </MainSection>

      {/* 다섯 번째 칸 */}
      <MainSection id="contact" $lightBg $mobileTight>
        <SectionContentNoCanvas>
          <SectionPulse />
          <SectionPulseRing />
          <motion.div {...sectionRevealProps()}>
            <ContactPanel>
              <ContactContent>
                <motion.div {...sectionRevealProps()}>
                  <ContactTitle>Let&apos;s Talk</ContactTitle>
                </motion.div>
                <motion.div {...sectionRevealProps(0.08)}>
                  <ContactSub>문의가 있으시면 아래로 연락해 주세요. Lacess가 함께 도와드릴게요.</ContactSub>
                </motion.div>
                <ContactList>
                  <motion.div {...sectionRevealProps(0.12)}>
                    <ContactItem>
                      <ContactIcon>
                        <MapPin size={17} strokeWidth={1.9} aria-hidden="true" />
                      </ContactIcon>
                      <div>
                        <ContactLabel>Address</ContactLabel>
                        <ContactValue>
                          경기도 성남시 분당구 판교로 255번길 9-22 우림 W-City 709호
                        </ContactValue>
                      </div>
                    </ContactItem>
                  </motion.div>
                  <motion.div {...sectionRevealProps(0.2)}>
                    <ContactItem>
                      <ContactIcon>
                        <Phone size={17} strokeWidth={1.9} aria-hidden="true" />
                      </ContactIcon>
                      <div>
                        <ContactLabel>Phone</ContactLabel>
                        <ContactValue>031-628-8605</ContactValue>
                      </div>
                    </ContactItem>
                  </motion.div>
                  <motion.div {...sectionRevealProps(0.28)}>
                    <ContactItem>
                      <ContactIcon>
                        <Printer size={17} strokeWidth={1.9} aria-hidden="true" />
                      </ContactIcon>
                      <div>
                        <ContactLabel>Fax</ContactLabel>
                        <ContactValue>031-628-8601</ContactValue>
                      </div>
                    </ContactItem>
                  </motion.div>
                </ContactList>
              </ContactContent>
            </ContactPanel>
          </motion.div>
        </SectionContentNoCanvas>
      </MainSection>

      <Footer />
    </DefaultContainer>
      </div>
    </>
  );
};

const MainSection = styled.section`
  position: relative;
  width: 100%;
  min-height: auto;
  display: flex;
  align-items: stretch;
  justify-content: center;
  box-sizing: border-box;
  padding: ${({ $compact, $lightBg }) =>
    $compact
      ? $lightBg
        ? "4.4rem 0 3.9rem"
        : "3.4rem 0 3.2rem"
      : $lightBg
      ? "5.2rem 0 4.6rem"
      : "4rem 0 3.6rem"};
  scroll-margin-top: 7vh;
  background: ${({ $lightBg }) =>
    $lightBg
      ? `
    radial-gradient(circle at 16% 12%, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 255, 0.93) 32%, transparent 56%),
    radial-gradient(circle at 84% 18%, rgba(235, 238, 255, 0.55) 0%, rgba(244, 246, 255, 0.22) 40%, transparent 64%),
    linear-gradient(140deg, #f8fbff 0%, #f0f5ff 44%, #f9fafe 100%)
  `
      : `
    radial-gradient(circle at 16% 12%, rgba(102, 122, 255, 0.14), transparent 31%),
    radial-gradient(circle at 84% 12%, rgba(45, 58, 152, 0.18), transparent 34%),
    radial-gradient(circle at 50% 82%, rgba(20, 27, 66, 0.23), transparent 29%),
    linear-gradient(140deg, #090d18 0%, #161d4f 44%, #0c1232 100%)
  `};

  @media (max-width: 1280px) {
    padding: ${({ $compact, $lightBg }) =>
      $compact
        ? $lightBg
          ? "3.9rem 0 3.5rem"
          : "3rem 0 2.6rem"
      : $lightBg
        ? "4.4rem 0.9rem 3.9rem"
        : "3.4rem 0 3rem"};
  }

  @media (max-width: 1024px) {
    padding: ${({ $compact, $lightBg }) =>
      $compact
        ? $lightBg
          ? "3.6rem 0 3.2rem"
          : "2.8rem 0 2.4rem"
      : $lightBg
        ? "4rem 0.8rem 3.4rem"
        : "3.1rem 0 2.8rem"};
  }

  @media (max-width: 768px) {
    padding: ${({ $compact, $lightBg, $mobileTight }) =>
      $compact
        ? $lightBg
          ? $mobileTight
            ? "2.25rem 0.55rem 1.8rem"
            : "3.15rem 0 2.8rem"
          : "2.4rem 0 2rem"
      : $lightBg
        ? $mobileTight
          ? "2.45rem 0.6rem 2rem"
          : "3.6rem 0.7rem 2.9rem"
        : "2.8rem 0 2.3rem"};
    background: ${({ $lightBg }) =>
      $lightBg
        ? `
      radial-gradient(circle at 16% 12%, rgba(255, 255, 255, 0.99) 0%, rgba(248, 250, 255, 0.92) 34%, transparent 58%),
      radial-gradient(circle at 84% 18%, rgba(232, 236, 255, 0.45) 0%, rgba(242, 245, 255, 0.18) 40%, transparent 66%),
      linear-gradient(140deg, #f9fbff 0%, #f2f7ff 44%, #f7faff 100%)
    `
        : `
      radial-gradient(circle at 16% 12%, rgba(102, 122, 255, 0.11), transparent 33%),
      radial-gradient(circle at 84% 12%, rgba(45, 58, 152, 0.14), transparent 36%),
      radial-gradient(circle at 50% 82%, rgba(20, 27, 66, 0.2), transparent 32%),
      linear-gradient(140deg, #0a0f20 0%, #141a3c 44%, #0a1028 100%)
    `};
  }

  @media (max-width: 480px) {
    padding: ${({ $compact, $lightBg, $mobileTight }) =>
      $compact
        ? $lightBg
          ? $mobileTight
            ? "1.85rem 0.45rem 1.45rem"
            : "2.8rem 0 2.4rem"
          : "2rem 0 1.8rem"
      : $lightBg
        ? $mobileTight
          ? "2.05rem 0.45rem 1.65rem"
          : "3.2rem 0.6rem 2.6rem"
        : "2.4rem 0 2rem"};
  }
`

const HeroBand = styled.section`
  display: block;
`

const HideScrollbar = createGlobalStyle`
  html,
  body {
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  html::-webkit-scrollbar,
  body::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
`

const pulseCore = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.28;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.12);
    opacity: 0.62;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.28;
  }
`

const pulseRing = keyframes`
  0% {
    transform: scale(0.95);
    opacity: 0.24;
  }
  50% {
    transform: scale(1.18);
    opacity: 0.58;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.24;
  }
`

const sweepMove = keyframes`
  0% {
    transform: translateX(-140%);
  }
  100% {
    transform: translateX(160%);
  }
`

const HeroPulse = styled.div`
  position: absolute;
  width: 30rem;
  height: 30rem;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(122, 142, 196, 0.26) 0%, rgba(122, 142, 196, 0.09) 35%, rgba(122, 142, 196, 0) 72%);
  filter: blur(16px);
  z-index: 1.2;
  pointer-events: none;
  animation: ${pulseCore} 3.8s cubic-bezier(0.45, 0.01, 0.35, 1) infinite;

  @media (max-width: 1024px) {
    width: 24rem;
    height: 24rem;
    filter: blur(12px);
  }

  @media (max-width: 640px) {
    width: 19rem;
    height: 19rem;
    filter: blur(10px);
  }
`

const HeroPulseRing = styled.div`
  position: absolute;
  width: 36rem;
  height: 36rem;
  left: 52%;
  top: 34%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 1px solid rgba(150, 166, 210, 0.22);
  box-shadow: 0 0 30px rgba(100, 118, 185, 0.26), inset 0 0 18px rgba(157, 175, 214, 0.15);
  z-index: 1.2;
  pointer-events: none;
  animation: ${pulseRing} 4.8s cubic-bezier(0.45, 0.01, 0.35, 1) infinite;

  @media (max-width: 1024px) {
    width: 29rem;
    height: 29rem;
    box-shadow: 0 0 22px rgba(100, 118, 185, 0.22), inset 0 0 14px rgba(157, 175, 214, 0.12);
  }

  @media (max-width: 640px) {
    width: 22rem;
    height: 22rem;
    box-shadow: 0 0 18px rgba(100, 118, 185, 0.2), inset 0 0 11px rgba(157, 175, 214, 0.11);
  }
`

const HeroSweep = styled.div`
  position: absolute;
  top: 22%;
  left: 0;
  width: 35%;
  height: 2px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(175, 193, 232, 0.5), rgba(255, 255, 255, 0));
  filter: blur(0.5px);
  opacity: 0.55;
  z-index: 1.3;
  animation: ${sweepMove} 11s linear infinite;
  pointer-events: none;

  @media (max-width: 1024px) {
    width: 50%;
    opacity: 0.4;
  }

  @media (max-width: 640px) {
    width: 60%;
    opacity: 0.34;
    height: 1.5px;
  }
`

const sectionPulse = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.92);
    opacity: 0.2;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.08);
    opacity: 0.46;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.92);
    opacity: 0.2;
  }
`

const sectionRing = keyframes`
  0% {
    transform: translateX(0) scale(0.95);
    opacity: 0.22;
  }
  50% {
    transform: translateX(1.2%) scale(1.05);
    opacity: 0.42;
  }
  100% {
    transform: translateX(0) scale(0.95);
    opacity: 0.22;
  }
`

const sectionPulseBiz = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.92) rotate(0deg);
    opacity: 0.22;
  }
  25% {
    transform: translate(-44%, -53%) scale(1.06) rotate(4.5deg);
    opacity: 0.34;
  }
  50% {
    transform: translate(-52%, -48%) scale(0.96) rotate(-3.5deg);
    opacity: 0.28;
  }
  75% {
    transform: translate(-47%, -46%) scale(1.03) rotate(6deg);
    opacity: 0.36;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.92) rotate(0deg);
    opacity: 0.22;
  }
`

const sectionRingBiz = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.94) rotate(0deg);
    opacity: 0.18;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.08) rotate(8deg);
    opacity: 0.38;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.94) rotate(0deg);
    opacity: 0.18;
  }
`

const sectionGlowShift = keyframes`
  0% {
    background-position: 10% 10%;
  }
  50% {
    background-position: 90% 90%;
  }
  100% {
    background-position: 10% 10%;
  }
`

const sectionScan = keyframes`
  0% {
    transform: translateX(-130%);
  }
  100% {
    transform: translateX(160%);
  }
`

const VisionPanel = styled.div`
  width: 100%;
  display: grid;
  gap: 1.1rem;
  position: relative;
  z-index: 1;
`

const SectionCanvas = styled.div`
  width: min(1180px, calc(100% - 6rem));
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(140, 154, 208, 0.2);
  border-radius: 28px;
  background: linear-gradient(170deg, rgba(15, 20, 42, 0.84) 0%, rgba(10, 13, 28, 0.9) 55%, rgba(7, 11, 24, 0.86) 100%);
  backdrop-filter: blur(9px);
  box-shadow: 0 20px 55px rgba(8, 12, 26, 0.5);
  padding: clamp(2rem, 4vw, 3rem);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      repeating-linear-gradient(
        90deg,
        rgba(140, 155, 216, 0.018) 0,
        rgba(140, 155, 216, 0.018) 1px,
        transparent 1px,
        transparent 74px
      ),
      repeating-linear-gradient(
        0deg,
        rgba(140, 155, 216, 0.016) 0,
        rgba(140, 155, 216, 0.016) 1px,
        transparent 1px,
        transparent 60px
      ),
      radial-gradient(circle at 8% 12%, rgba(140, 156, 216, 0.13), transparent 32%),
      radial-gradient(circle at 92% 8%, rgba(90, 111, 173, 0.15), transparent 34%),
      radial-gradient(circle at 56% 92%, rgba(46, 60, 100, 0.16), transparent 30%);
    background-size: 180% 180%;
    animation: ${sectionGlowShift} 14s ease-in-out infinite;
    z-index: 0;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    top: 12%;
    left: -35%;
    width: 60%;
    height: 2px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(173, 192, 235, 0.56), rgba(255, 255, 255, 0));
    filter: blur(0.4px);
    opacity: 0.5;
    z-index: 0;
    pointer-events: none;
    animation: ${sectionScan} 12.5s linear infinite;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 1200px) {
    width: min(1160px, calc(100% - 3.4rem));
    padding: clamp(1.35rem, 3.2vw, 2.1rem);
  }

  @media (max-width: 1024px) {
    width: min(1180px, calc(100% - 3.2rem));
    padding: clamp(1.45rem, 3.4vw, 2rem);
  }

  @media (max-width: 768px) {
    width: min(1180px, calc(100% - 2rem));
    border-radius: 18px;
    padding: clamp(0.95rem, 4vw, 1.5rem);
  }

  @media (max-width: 480px) {
    width: calc(100% - 1.2rem);
    padding: clamp(0.85rem, 4.2vw, 1.25rem);
  }
`

const SectionContentNoCanvas = styled.div`
  width: min(100%, 940px);
  padding: 0 1.5rem;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 1;

  @media (max-width: 1024px) {
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    padding: 0 0.8rem;
  }

  @media (max-width: 480px) {
    padding: 0 0.5rem;
  }
`

const SectionPulse = styled.div`
  position: absolute;
  width: 28rem;
  height: 28rem;
  left: 50%;
  top: 16%;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  background: radial-gradient(circle, rgba(126, 145, 198, 0.22) 0%, rgba(126, 145, 198, 0.08) 40%, rgba(126, 145, 198, 0) 72%);
  filter: blur(18px);
  animation: ${sectionPulse} 4.5s cubic-bezier(0.45, 0.01, 0.35, 1) infinite;
  pointer-events: none;
  z-index: 0;

  @media (max-width: 1024px) {
    width: 22rem;
    height: 22rem;
    filter: blur(14px);
  }

  @media (max-width: 640px) {
    width: 17rem;
    height: 17rem;
    filter: blur(12px);
    top: 16%;
  }
`

const SectionPulseRing = styled.div`
  position: absolute;
  width: 34rem;
  height: 34rem;
  left: 50%;
  top: 16%;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  border: 1px solid rgba(148, 164, 214, 0.2);
  box-shadow: 0 0 28px rgba(98, 116, 178, 0.22), inset 0 0 18px rgba(130, 146, 196, 0.14);
  animation: ${sectionRing} 4.8s cubic-bezier(0.45, 0.01, 0.35, 1) infinite;
  pointer-events: none;
  z-index: 0;

  @media (max-width: 1024px) {
    width: 26rem;
    height: 26rem;
  }

  @media (max-width: 640px) {
    width: 20rem;
    height: 20rem;
  }
`

const SectionPulseBiz = styled(SectionPulse)`
  top: 20%;
  width: 31rem;
  height: 31rem;
  filter: blur(14px);
  background: radial-gradient(circle, rgba(120, 158, 215, 0.26) 0%, rgba(120, 158, 215, 0.08) 40%, rgba(120, 158, 215, 0) 72%);
  animation: ${sectionPulseBiz} 5.2s cubic-bezier(0.38, 0.01, 0.36, 1) infinite;

  @media (max-width: 1024px) {
    width: 24rem;
    height: 24rem;
    filter: blur(12px);
  }

  @media (max-width: 640px) {
    width: 19rem;
    height: 19rem;
    filter: blur(11px);
  }
`

const SectionPulseRingBiz = styled(SectionPulseRing)`
  top: 20%;
  width: 37rem;
  height: 37rem;
  animation: ${sectionRingBiz} 5.4s cubic-bezier(0.38, 0.01, 0.36, 1) infinite;

  @media (max-width: 1024px) {
    width: 28rem;
    height: 28rem;
  }

  @media (max-width: 640px) {
    width: 21rem;
    height: 21rem;
  }
`

const CompanyEyebrow = styled.p`
  margin: 0;
  color: #a1b1e0;
  font-size: 0.85rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  font-weight: 700;
`

const CompanyTitle = styled.h2`
  margin: 0;
  font-size: clamp(1.8rem, 4.5vw, 3.2rem);
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-shadow: 0 0 16px rgba(196, 205, 255, 0.26);
  max-width: 20ch;
`

const CompanyMission = styled.p`
  margin: 0;
  color: #dae2f6;
  font-size: 1.05rem;
  line-height: 1.65;
  text-shadow: 0 0 10px rgba(185, 206, 255, 0.16);
  max-width: 72ch;

  @media (max-width: 768px) {
    font-size: 0.96rem;
    line-height: 1.52;
  }
`

const MainAction = styled(Link)`
  margin-top: 0.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  min-width: 150px;
  height: 46px;
  padding: 0 1.3rem;
  border-radius: 999px;
  border: 1px solid rgba(171, 185, 225, 0.56);
  color: #eef3ff;
  text-decoration: none;
  background: linear-gradient(120deg, rgba(38, 48, 96, 0.72), rgba(20, 27, 57, 0.58));
  box-shadow: 0 8px 20px rgba(15, 21, 45, 0.34);
  transition: transform 0.2s ease, background 0.2s ease;
  text-shadow: 0 0 16px rgba(196, 215, 255, 0.3);

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(120deg, rgba(58, 73, 140, 0.8), rgba(34, 45, 91, 0.78));
    box-shadow: 0 10px 22px rgba(49, 72, 178, 0.38);
  }

  @media (max-width: 768px) {
    width: min(100%, 14rem);
    padding: 0.62rem 1.1rem;
  }
`

const SectionLabel = styled.div`
  color: #c1cdf6;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  margin-left: 0;
  text-shadow: 0 0 10px rgba(181, 200, 255, 0.18);

  @media (max-width: 768px) {
    margin-top: 1.4rem;
  }
`;

const BizJumpButton = styled(Link)`
  display: inline-flex;
  width: fit-content;
  align-self: flex-start;
  margin: 0.55rem 0 1.4rem;
  padding: 0.58rem 1rem;
  border-radius: 999px;
  border: 1px solid rgba(189, 206, 255, 0.6);
  color: #e9f0ff;
  text-decoration: none;
  font-size: 0.86rem;
  font-weight: 700;
  background: linear-gradient(120deg, rgba(34, 49, 122, 0.86), rgba(20, 27, 63, 0.66));
  box-shadow: 0 10px 22px rgba(17, 24, 56, 0.42);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;

  &:hover {
    border-color: rgba(238, 242, 255, 0.82);
    box-shadow: 0 12px 24px rgba(56, 79, 168, 0.52);
    transform: translateY(-1px);
  }

  @media (max-width: 1024px) {
    margin: 0.75rem 0 1.7rem;
  }

  @media (max-width: 768px) {
    margin: 0.8rem 0 1.5rem;
    width: min(100%, 16rem);
    padding: 0.62rem 1.05rem;
    font-size: 0.84rem;
  }

  @media (max-width: 640px) {
    width: min(100%, 16rem);
    justify-content: center;
    padding: 0.56rem 0.95rem;
    margin: 0.78rem 0 1.5rem;
  }
`

const SectionHeading = styled.h3`
  margin: 0 0 0.7rem;
  color: #f1f5ff;
  font-size: clamp(1.8rem, 3.4vw, 2.6rem);
  font-weight: 800;
  letter-spacing: -0.01em;
  text-shadow: 0 0 14px rgba(184, 200, 255, 0.22);

  @media (max-width: 768px) {
    margin: 0 0 0.7rem;
    font-size: 1.6rem;
  }
`

const SectionLead = styled.p`
  color: #d8e2ff;
  margin: 0 0 0.8rem;
  font-size: 1.05rem;
  line-height: 1.6;
  max-width: 70ch;
  text-shadow: 0 0 8px rgba(181, 202, 255, 0.16);

  @media (max-width: 768px) {
    margin: 0 0 0.8rem;
    font-size: 0.95rem;
    line-height: 1.55;
  }
`

const VendorGrid = styled.div`
  width: calc(100% - 1.2rem);
  margin: 1.3rem auto 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.2rem;

  @media (max-width: 768px) {
    width: 100%;
    grid-template-columns: 1fr;
    margin-top: 1.2rem;
  }
`

const VendorDescriptionGrid = styled.div`
  margin: 1rem auto 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
`

const VendorDescriptionCard = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(160, 178, 228, 0.24);
  background: linear-gradient(145deg, rgba(17, 27, 61, 0.46) 0%, rgba(12, 18, 39, 0.58) 100%);
  padding: 0.95rem 0.95rem 0.9rem;
  box-shadow: 0 10px 24px rgba(8, 12, 28, 0.3);
  backdrop-filter: blur(4px);
  min-height: 96px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const VendorDescriptionTitle = styled.div`
  color: #edf2ff;
  font-weight: 800;
  font-size: 0.96rem;
  margin-bottom: 0.42rem;
`

const VendorDescriptionText = styled.p`
  margin: 0;
  color: #d6e0f7;
  font-size: 0.89rem;
  line-height: 1.6;
`

const VendorCardItem = styled(motion.div)`
  background: linear-gradient(160deg, rgba(20, 29, 60, 0.56) 0%, rgba(11, 17, 39, 0.56) 100%);
  border: 1px solid rgba(150, 165, 230, 0.2);
  position: relative;
  backdrop-filter: blur(6px);
  border-radius: 12px;
  padding: 0.25rem;
  overflow: hidden;
  transform: translateY(0);
  transition: transform 0.28s ease, border-color 0.28s ease, box-shadow 0.28s ease;
  box-shadow: 0 12px 24px rgba(9, 14, 34, 0.35);

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(189, 200, 255, 0.34);
    box-shadow: 0 12px 28px rgba(35, 48, 112, 0.34);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: linear-gradient(120deg, rgba(174, 196, 255, 0.18), rgba(87, 110, 236, 0.02) 55%, rgba(174, 196, 255, 0.12));
    opacity: 0.22;
    pointer-events: none;
    transition: opacity 0.25s ease;
  }

  &:hover::after {
    opacity: 0.48;
  }
`

const ContactContent = styled.div`
  width: 100%;
  max-width: none;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  color: #e4ebff;

  @media (max-width: 768px) {
    gap: 0.75rem;
  }

  @media (max-width: 480px) {
    gap: 0.62rem;
  }
`

const ContactPanel = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(170deg, rgba(16, 22, 47, 0.68) 0%, rgba(11, 16, 32, 0.74) 100%);
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(150, 168, 241, 0.2);
  padding: 1.35rem 1.35rem;
  gap: 0.85rem;
  color: #e4ebff;
  box-shadow: 0 10px 22px rgba(7, 9, 24, 0.3);
  backdrop-filter: blur(4px);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 72% 0%, rgba(146, 163, 245, 0.13), transparent 45%),
      radial-gradient(circle at 24% 95%, rgba(82, 102, 186, 0.14), transparent 36%);
    pointer-events: none;
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 1200px) {
    height: auto;
    margin-top: 0.2rem;
  }

  @media (max-width: 768px) {
    padding: 1.08rem 1rem;
    border-radius: 14px;
    margin-top: 0.18rem;
  }

  @media (max-width: 480px) {
    padding: 0.82rem 0.78rem;
    border-radius: 12px;
    margin-top: 0.12rem;
  }
`

const ContactTitle = styled.h4`
  margin: 0;
  font-size: 1.25rem;
  color: #d8e0fa;
  font-weight: 800;
  text-shadow: 0 0 14px rgba(178, 195, 255, 0.24);

  @media (max-width: 768px) {
    font-size: 1.15rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`

const ContactSub = styled.p`
  margin: 0.05rem 0 0.2rem;
  color: #c3d0f0;
  font-size: 0.92rem;
  line-height: 1.45;
  text-shadow: 0 0 8px rgba(179, 199, 255, 0.14);

  @media (max-width: 768px) {
    font-size: 0.88rem;
    line-height: 1.42;
  }

  @media (max-width: 480px) {
    font-size: 0.79rem;
    line-height: 1.34;
  }
`

const ContactList = styled.div`
  display: grid;
  gap: 0.8rem;

  @media (max-width: 480px) {
    gap: 0.62rem;
  }
`

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.45rem 0;

  @media (max-width: 768px) {
    gap: 0.65rem;
    padding: 0.38rem 0;
  }

  @media (max-width: 480px) {
    gap: 0.58rem;
    padding: 0.3rem 0;
  }
`

const ContactIcon = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  margin-top: 0.02rem;
  border-radius: 10px;
  background: linear-gradient(145deg, rgba(168, 190, 255, 0.2), rgba(130, 151, 214, 0.16));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #e7f0ff;
  box-shadow: inset 0 0 6px rgba(182, 205, 255, 0.16);
  border: 1px solid rgba(190, 208, 249, 0.32);

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    min-width: 30px;
  }

  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
    min-width: 28px;
  }
`

const ContactLabel = styled.div`
  color: #b2c0e8;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.07em;
  font-weight: 700;
  margin-bottom: 0.2rem;
`

const ContactValue = styled.div`
  color: #e6edff;
  line-height: 1.4;
  font-size: 0.98rem;

  @media (max-width: 768px) {
    font-size: 0.92rem;
  }

  @media (max-width: 480px) {
    font-size: 0.86rem;
    line-height: 1.32;
  }
`

const HeroTitle = styled(motion.h1)`
  color: #fff;
  text-align: center;
  margin: 0;
  margin-bottom: 1.7rem;
  font-weight: 800;
  max-width: 72rem;
  font-size: clamp(2rem, 7.4vw, 4rem);
  line-height: 1.08;
  text-shadow: 0 10px 40px rgba(102, 122, 255, 0.26);

  @media (max-width: 1024px) {
    max-width: 90%;
    line-height: 1.15;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
    letter-spacing: -0.02em;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
    max-width: 94%;
    padding: 0 0.5rem;
  }
`;

const HeroDescription = styled(motion.p)`
  color: #fff;
  text-align: center;
  max-width: 36rem;
  margin: 0 auto 2.1rem;
  font-size: 1.125rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
    max-width: 92%;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

const HeroCTA = styled(motion(Link))`
  margin: 0.4rem auto 0;
  width: fit-content;
  max-width: 100%;
  padding: 0.72rem 1.5rem;
  border-radius: 999px;
  border: 1px solid rgba(191, 207, 255, 0.72);
  background: linear-gradient(120deg, rgba(43, 58, 168, 0.62), rgba(22, 29, 62, 0.65));
  color: #f2f6ff;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow: 0 8px 24px rgba(30, 42, 102, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(230, 235, 255, 0.92);
    box-shadow: 0 8px 24px rgba(70, 86, 172, 0.45);
  }

  @media (max-width: 768px) {
    width: min(100%, 15rem);
    padding: 0.64rem 1.2rem;
  }
`

export default Main;
